// extracted by mini-css-extract-plugin
module.exports = {"Error":"Error_Error__3jYz-","Message":"Error_Message__Czsww"};